module.exports = __webpack_public_path__ + "4391056e28653aa7e2ce6b3e858af5af.png";